import * as React from 'react';

import { Card, CardContent, type CardProps, Text } from '@/design-system/components/ui';
import { cn } from '@/design-system/lib/utils';

export interface StatCardProps extends Omit<CardProps, 'overflow'> {
  icon?: React.ReactNode;
  label: React.ReactNode;
  /** Main amount/text rendered with the canonical StatCard value style. */
  value?: React.ReactNode;
  headerAction?: React.ReactNode;
}

const StatCard = React.forwardRef<HTMLDivElement, StatCardProps>(
  ({ icon, label, value, headerAction, variant = 'default', children, className, ...props }, ref) => (
    <Card ref={ref} variant={variant} className={className} {...props}>
      <CardContent className="tw:flex tw:flex-col tw:gap-2 tw:p-4 tw:px-6">
        <div className={cn('tw:flex tw:flex-row tw:items-center tw:gap-2', headerAction && 'tw:justify-between')}>
          <div className="tw:flex tw:flex-row tw:items-center tw:gap-2">
            {icon && (
              <div className="tw:shrink-0 tw:h-6 tw:w-6" aria-hidden="true">
                {icon}
              </div>
            )}
            <Text variant="body-md" color="muted">
              {label}
            </Text>
          </div>
          {headerAction}
        </div>
        {value !== undefined && (
          <Text variant="body-2xl" weight="medium">
            {value}
          </Text>
        )}
        {children}
      </CardContent>
    </Card>
  ),
);

StatCard.displayName = 'StatCard';

export { StatCard };
